import MicrosoftLogo from '@/assets/images/microsoft.svg';

const MicrosoftIcon = ({ size = 25 }) => (
    <img
        src={MicrosoftLogo}
        alt="Microsoft Logo"
        style={{ height: size, width: size }}
    />
);

export default MicrosoftIcon;
